<template>
    <div class="stake-section">
        <div class="stake-section-background"
            :style="{ backgroundImage: `url(${stakeImage})` }">
            <div class="stake-section-text">
                <div class="text-line">High-stakes casino action meets</div>
                <div class="text-line">FIFA-level football intensity.</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StakeSection',
    data() {
        return {
            stakeImage: require('@/assets/img/banner/stake_section.jpg')
        }
    }
}
</script>

<style scoped>
.stake-section {
    position: relative;
    overflow: hidden;
    margin: 21px 21px var(--spacing-xl) 21px;
}

.stake-section-background {
    width: 100%;
    min-height: 320px;
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: var(--spacing-xl);
}

.stake-section-text {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    max-width: 60%;
    z-index: 2;
}

.text-line {
    font-family: 'Anton SC', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 40px;
    line-height: 50px;
    letter-spacing: 0%;
    text-align: right;
    color: var(--gradient-txt-yellow);
    background: var(--gradient-txt-yellow);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

@media only screen and (max-width: 768px) {
    .stake-section {
        margin: 40px var(--spacing-md) var(--spacing-md) var(--spacing-md);
    }

    .stake-section-background {
        min-height: 200px;
        padding: var(--spacing-lg);
    }

    .stake-section-text {
        max-width: 70%;
    }

    .stake-section-text .text-line {
        font-size: 28px;
        line-height: 36px;
    }
}

@media only screen and (max-width: 480px) {
    .stake-section {
        margin: 30px var(--spacing-sm) var(--spacing-sm) var(--spacing-sm);
    }

    .stake-section-background {
        min-height: 150px;
        padding: var(--spacing-md);
    }

    .stake-section-text {
        max-width: 80%;
    }

    .stake-section-text .text-line {
        font-size: 20px;
        line-height: 28px;
    }
}
</style>
